/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pure_Green_Toad_GrowInputs */

const en_pure_green_toad_grow = /** @type {(inputs: Pure_Green_Toad_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by attribute`)
};

const de_pure_green_toad_grow = /** @type {(inputs: Pure_Green_Toad_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Merkmal filtern`)
};

/**
* | output |
* | --- |
* | "Filter by attribute" |
*
* @param {Pure_Green_Toad_GrowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pure_green_toad_grow = /** @type {((inputs?: Pure_Green_Toad_GrowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pure_Green_Toad_GrowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pure_green_toad_grow(inputs)
	return de_pure_green_toad_grow(inputs)
});